import styled, { css } from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** Not positioned on purpose: the panel is placed against the CALLER'S nearest positioned ancestor (the group heading,
 *  full width), so it can't run off a phone screen the way a panel hung off an 18px glyph would. */
export const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
`;

/** A bare info glyph that is still a real button (hit area, focus ring). */
export const Trigger = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: none;
  color: ${COLORS.textMuted};
  cursor: pointer;

  &:hover,
  &:focus-visible,
  &[aria-expanded='true'] {
    color: ${COLORS.textStrong};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;

/** The explanation: kept in the DOM while closed (`hidden`) so the trigger's `aria-describedby` always resolves.
 *  Under the caller's positioned box, from its start or end edge. */
export const Panel = styled.span<{ $align: 'start' | 'end' }>`
  position: absolute;
  top: calc(100% + ${SPACE[8]});
  ${(p) =>
    p.$align === 'end'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
  z-index: 2;
  box-sizing: border-box;
  width: 320px;
  max-width: 100%;
  padding: ${SPACE[12]} ${SPACE[16]};
  border-radius: 12px;
  border: 1px solid ${COLORS.surfaceMuted};
  background: ${COLORS.surfaceCard};
  box-shadow: ${COLORS.menuShadow};
  white-space: normal;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;

  &[hidden] {
    display: none;
  }
`;

export const PanelText = styled(Text)`
  display: block;

  & + & {
    margin-top: ${SPACE[8]};
  }

  color: ${COLORS.textMuted};
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
`;
